import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {map, tap, filter, catchError, mergeMap} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {BASE_URL} from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner";
import {AuthService} from './../../login/auth.service';
import {Router} from '@angular/router';

@Injectable()
export class StoresService {
  public DASBOARD_URL = BASE_URL.URL;
  private userId: any;
  private token: any;

  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private authService: AuthService, private route: Router) { 

  }

  getStores(warehouseId: number|string, fields: Array<String> = []): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores?warehouse_id=${warehouseId}&fields=${fields}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  } 

  getImplants(storeId: string, type: string, page: string = "", search: string = "", expiry: string = "", cabinets: Array<string> = []): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/implants?type=${type}&page=${page}&expiry=${expiry}&cabinets=${cabinets}&search=${search}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  } 

  downloadImplants(storeId: string, type: string, page: string = "", search: string = "", expiry: string = "", cabinets: Array<string> = []): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/implants?type=${type}&page=${page}&expiry=${expiry}&cabinets=${cabinets}&search=${search}&download=1`, {
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  } 

  getStoreDetails(storeId: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getImplantDetails(storeId: string, implantId: string = ""): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/implants/${implantId}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getLowStockProductDetails(storeId: string, productId: string): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/low_stocks/${productId}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  consumeImplants(storeId: string|number, body: { implant_id: Array<string|number>, store_id: string|number }): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.post(`${this.DASBOARD_URL}/stores/${storeId}/implants/consume`, body,{
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  resetStatus(storeId: string|number, body: { implant_id: Array<string|number> }): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.post(`${this.DASBOARD_URL}/stores/${storeId}/implants/reset-status`, body,{
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  findImplants(type: string, page: string = "", search: string = "", expiry: string = "", cabinets: Array<string> = []): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/implants/all?type=${type}&page=${page}&expiry=${expiry}&cabinets=${cabinets}&search=${search}`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }
  
  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else{
      console.error('server error:', error);
    }

  }
}
